import React from 'react';
import { Margin, P } from '@ovotech/element-v4';
import { ModalStepTitle } from '@/src/pages/AnytimeEligibilityV2/pages/PreEligibilityProducts/PreEligibilityProducts.styled';

export const WhatYouGetStep3: React.FC = () => (
  <Margin top={6}>
    <ModalStepTitle>Multiple EVs</ModalStepTitle>
    <Margin bottom={4}>
      <P>
        If you have more than one EV in your household you can charge them all
        with a Plus plan – provided the EVs or the charger are compatible.
      </P>
    </Margin>
    <Margin bottom={4}>
      <P>
        Check our list of compatible EVs and chargers. If your charger is
        compatible then you can use it to charge any EV.{' '}
      </P>
    </Margin>
  </Margin>
);
